/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetEntityIdentifiers = require('../../common/services/GetEntityIdentifiers');
var GetLicenseTypesByAllowNew = require('../services/GetLicenseTypesByAllowNew');
var GetEntityLocations = require('../../common/services/GetEntityLocations');

var NewLicenseApplicationView = require('../views/NewLicenseApplicationView');

module.exports = function(entityId) {
  NProgress.start();
  NProgress.set(0.6);
  $.when(GetLicenseTypesByAllowNew(), GetEntityIdentifiers(entityId), GetEntityLocations(entityId))
    .done(function(licenseTypes, entityIdentifiers, entityLocations) {
      NavUtils.navigate('ext/nondep/entity/' + entityId + '/license-app/new');
      Scaffold.content.show(
        new NewLicenseApplicationView({
          model: new Backbone.Model({
            entityIdentifiers: entityIdentifiers,
            licenseTypes: licenseTypes,
            entityLocations: entityLocations
          })
        })
      );
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
